export function getUserList(search, isEmployee) {
    let { getUserListRequest, getUserListError, getUserListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_user_list',
        this.createBundle('get_user_list', { search }, this.GET, getUserListRequest, getUserListResult, getUserListError, isEmployee)
    )
}
